module.exports = __webpack_public_path__ + "img/hypermeteo-logotipo.c608222b.png";